import {listStyles} from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

listStyles.wrapper = {
    css: css`
        margin-top: 0;
    `,
};

listStyles.cardList = {
    gridContainer: {
        gap: 0,
        css: css`
            margin: 20px 0;
        `,
        offsetProps: { style: { width: "100%", gap: 20, } },
    },
};

listStyles.cardContainerStyles = {
    gridItem: {
        css: css`
            border-bottom: none;
        `,
    },
    cardDivider: {
        css: css`
            width: 100%;
            border: 1px solid ${getColor("common.border")};
        `,
    },
};

listStyles.cardContainerMultiColumnStyles = {
    cardDivider: {
        css: css`
            padding: 0;
            height: 100%;
            width: 100%;
            overflow: hidden;
            max-width: 450px;
        `,
    },
    gridItem: {
        css: css`
            border-bottom: none;
            border: ${getColor("common.border")} 1px solid;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        max-width: calc(33.333333% - 14px) !important;
                    `,
                    null,
                    null,
                ],
                "min",
            )}
        `,
    },
};
